import React from 'react';
import Newsletter, { type NewsletterProps } from '../../../react4xp/components/Newsletter'

function NewsletterPart (props: NewsletterProps) {
  return (
    <Newsletter {...props} />
  )
}

export default (props: NewsletterProps) => <NewsletterPart {...props} />
